import * as React from "react";
import { useTranslation } from "react-i18next";
import LimitsAndClosureNavigationPanel from "../../components/LimitsAndClosureNavigationPanel/LimitsAndClosureNavigationPanel";
import LimitsAndClosureContainer from "../../containers/LimitsAndClosureContainter/LimitsAndClosureContainer";

// tslint:disable-next-line:no-var-requires
const styles = require("./LimitsAndClosureScreen.scss");

export const LimitsAndClosureScreen = () => {
    const { t } = useTranslation("limits");
    const { screen, setActiveScreen } = useScreen("PayInLimitScreen");
    return (
        <div className={styles.greyBackground}>
            <LimitsAndClosureContainer
                navigation={setActiveScreen}
                activeScreen={screen}
                t={t}
            />
            <LimitsAndClosureNavigationPanel
                handleClick={setActiveScreen}
                t={t}
            />
        </div>
    );
};

const useScreen = (defaultScreen: string) => {
    const [screen, setScreen] = React.useState(defaultScreen);

    const setActiveScreen = (e: React.BaseSyntheticEvent) => {
        const { value } = e.target;
        setScreen(value);
    };

    return {
        screen,
        setActiveScreen
    };
};
